import {FieldInput, FormSection} from "../../ui";
import {SlsWarehouseAddressForm, SlsWarehouseAddressFormData} from "./SlsWarehouseAddressForm";

interface SlsWarehouseFormData {
    name: string
    warehouseNumber: string
    addresses: SlsWarehouseAddressFormData[]
}

interface SlsWarehouseFormHelp {
    name?: string
    warehouseNumber?: string
}

interface SlsWarehouseFormProps {
    value: SlsWarehouseFormData
    help: SlsWarehouseFormHelp
    disabled: boolean
    onChange: (value: SlsWarehouseFormData) => any
    onDelete: (position: number) => any
    addAddress: (value: SlsWarehouseAddressFormData[]) => any
    validate: () => Promise<any>
    validationFor: (p: string) => string | undefined
}

function SlsWarehouseForm({
                              value,
                              help,
                              disabled,
                              onChange,
                              onDelete,
                              validate,
                              validationFor,
                              addAddress
                          }: SlsWarehouseFormProps) {
    return <div style={{flex: '1', overflow: 'auto', padding: '1em'}}>
        <div className={"columns"}>
            <div className={"column is-one-third"}>
                <FieldInput
                    label={"Name"}
                    required={true}
                    onChange={v => {
                        onChange({
                            ...value,
                            name: v
                        })
                    }}
                    help={help.name}
                    invalid={Boolean(help.name)}
                    disabled={disabled}
                    onBlur={async () => await validate()}
                    value={value.name}
                />
            </div>
            <div className={"column is-one-third"}>
                <FieldInput
                    label={"Nummer"}
                    required={true}
                    disabled={disabled}
                    onChange={v => {
                        onChange({
                            ...value,
                            warehouseNumber: v
                        })
                    }}
                    help={help.warehouseNumber}
                    invalid={Boolean(help.warehouseNumber)}
                    onBlur={async () => await validate()}
                    value={value.warehouseNumber}
                />
            </div>
        </div>
        <FormSection
            label={"Interne Adressen"}
            children={
            <>
                {
                    value.addresses.map((address, i) =>
                        <SlsWarehouseAddressForm
                            disabled={disabled}
                            key={`internalAddresses[${i}]`}
                            position={i}
                            validationFor={validationFor}
                            data={address}
                            onBlur={async () => await validate()}
                            onChange={v => {
                                const addresses = [...value.addresses]
                                addresses[i] = v
                                onChange({...value,
                                    addresses: addresses})
                            }}
                            onDelete={onDelete}/>
                    )
                }
                <button
                    type={'button'}
                    disabled={disabled}
                    className={'button is-primary is-rounded is-small'}
                    onClick={() => {
                        addAddress([...value.addresses, {
                            city: '',
                            country: '',
                            houseNumber: '',
                            postCode: '',
                            street: ''
                        }])
                    }}>
                    Interne Adresse hinzufügen
                </button>
            </>
            }
            />
    </div>
}

export {
    SlsWarehouseForm
}
